// extracted by mini-css-extract-plugin
export default {"movie":"Movie_movie__EWQG-","holder":"Movie_holder__bOO3p","iks":"Movie_iks__YTytc","line1":"Movie_line1__C5Kns","line2":"Movie_line2__HxEy2","read-more":"Movie_read-more__dZif0"};